import { render, staticRenderFns } from "./PresentationCardNoImg.vue?vue&type=template&id=e95a8d96&scoped=true"
import script from "./PresentationCardNoImg.vue?vue&type=script&lang=js"
export * from "./PresentationCardNoImg.vue?vue&type=script&lang=js"
import style0 from "./PresentationCardNoImg.vue?vue&type=style&index=0&id=e95a8d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95a8d96",
  null
  
)

export default component.exports